<!--
 * @Description: 合作伙伴详情
 * @Author: cxh
 * @Date: 2022-05-24 15:19:34
 * @LastEditTime: 2022-11-07 16:32:29
 * @LastEditors: cxh
-->
<template>
  <dc-layout-main>
    <dc-layout-content>
      <CosViewContent
        header
        :title="data?.customerInfo?.customerName"
        :sellerName="data?.customerInfo?.sellerName"
        :collection-id="data?.collectionId"
        customLabel="联系人姓名"
        :customValue="data?.contact?.name"
        :add-fav="addFavorite"
        :cancel-fav="cancelFavorite"
      >
        <a-tabs @change="changeTabs" v-model:activeKey="activeKey">
          <a-tab-pane key="base" tab="基本信息">
            <baseMessage
              :disabled="true"
              :perfect="true"
              :data="data"
              :isEdit="false"
              type="clients"
              :content="['customerInfo', 'business']"
              :permissionPage="permissionBasic"
              view
            />
          </a-tab-pane>
          <a-tab-pane key="contact" tab="联系人">
            <TabsContacts
              ref="contactsRef"
              appId="cos_lbu"
              :contactRefId="route.query.cosId"
              :permissionPage="permissionConcat"
            />
          </a-tab-pane>
          <a-tab-pane key="3" tab="跟进记录">
            <TabsClueCosFollowUp
              appId="cos_lbu"
              :showFooter="true"
              :followRefId="route.query.cosId"
              :permissionPage="permissionFollow"
            />
          </a-tab-pane>
          <a-tab-pane key="4" tab="商机">
            <tabsBusiness :permissionPage="permissionBuss" />
          </a-tab-pane>
          <a-tab-pane key="6" tab="转化记录">
            <TabsConversion :resourceId="route.query.cosId" appId="cos_lbu" />
          </a-tab-pane>
          <a-tab-pane key="operationLog" tab="操作日志">
            <TabsOperationLog
              ref="operationLogRef"
              tableId="LbuClientsOperationLog"
              appId="cos_lbu"
              :resourceId="route.query.cosId"
            />
          </a-tab-pane>
          <a-tab-pane key="tungeeInfo" tab="探迹信息">
            <TabsTungee
              appId="cos_lbu"
              ref="tungeeRef"
              :cosId="route.query.cosId"
              :customerName="data?.customerInfo?.customerName"
            />
          </a-tab-pane>
        </a-tabs>
      </CosViewContent>
      <ViewFooterBtn
        :permissionPage="permissionBasic"
        @success="footerSuccess"
        :loading="loading"
        type="clients"
        :workCode="data?.customerInfo?.seller"
        :customerName="data?.customerInfo?.customerName"
      />
    </dc-layout-content>
  </dc-layout-main>
</template>
<script lang="ts" setup>
import { onMounted, ref } from 'vue'
import TabsOperationLog from '@/components/TabsOperationLog/index.vue'
import TabsConversion from '@/components/TabsConversion'
import TabsTungee from '@/components/TabsTungee/index.vue'
import TabsContacts from '@/components/TabsContacts/index.vue'
import TabsClueCosFollowUp from '@/components/TabsClueCosFollowUp'
import baseMessage from '@/views/yuntuSales/customerCenter/components/baseMessage.vue'
import ViewFooterBtn from '@/views/yuntuSales/customerCenter/components/viewFooterBtn.vue'
import tabsBusiness from '@/views/yuntuSales/customerCenter/components/tabsBusiness.vue'
import { potentialDetail } from '@/api/yuntuSales/customerCenter'
import { useRoute } from 'vue-router'
import { addToFav, cancelToFav } from '@/api/common'
const route = useRoute()
const data = ref({})
const operationLogRef = ref()
const tungeeRef = ref()
const activeKey = ref('base')
const contactsRef = ref()
const loading = ref(false)
// 获取详情
const fetch = () => {
  if (route.query.cosId) {
    loading.value = true
    potentialDetail(route.query.cosId)
      .then((res) => {
        data.value = res.data
      })
      .finally(() => {
        loading.value = false
      })
  }
}
onMounted(() => {
  fetch()
})
// 标签页切换
const changeTabs = (v: string) => {
  if (v === 'base') {
    fetch()
  } else if (v === 'operationLog') {
    operationLogRef.value?.fetch()
  }
}
const footerSuccess = (tag: 'base' | 'contact' | 'tungee') => {
  if (tag === 'base') {
    fetch()
  } else if (tag === 'contact') {
    // 更新联系人或者操作日志
    if (activeKey.value === 'contact') {
      contactsRef.value?.refresh()
    } else if (activeKey.value === 'operationLog') {
      operationLogRef.value?.fetch()
    }
  } else if (tag === 'tungee') {
    tungeeRef.value?.fetch()
  }
}
// 收藏
const addFavorite = () => {
  addToFav({
    appId: 'cos_lbu',
    cosId: data.value.customerInfo.cosId,
    stage: 4
  }).then((res) => {
    if (res.code === 200) {
      data.value.collectionId = data.value.customerInfo.cosId
    }
  })
}
// 收藏
const cancelFavorite = () => {
  cancelToFav({
    appId: 'cos_lbu',
    cosId: data.value.customerInfo.cosId,
    stage: 4
  }).then((res) => {
    if (res.code === 200) {
      data.value.collectionId = null
      data.value.collectionTime = null
    }
  })
}
const permissionBasic = {
  transfer: 'lbu_clients_transfer_btn',
  visitor_add: 'lbu_clients_visitor_add_btn',
  edit: 'lbu_clients_edit_btn',
  follow_add: 'lbu_clients_follow_add_btn',
  buss_add: 'lbu_clients_buss_add_btn',
  concat_add: 'lbu_clients_concat_add_btn'
}
const permissionFollow = {
  edit: 'lbu_clients_follow_edit_btn',
  del: 'lbu_clients_follow_del_btn'
}
const permissionBuss = {
  edit: 'lbu_clients_buss_edit_btn',
  del: 'lbu_clients_buss_del_btn'
}
const permissionConcat = {
  edit: 'lbu_clients_concat_edit_btn',
  del: 'lbu_clients_concat_del_btn'
}
</script>
<script lang="ts">
export default {
  name: 'LbuClientsView'
}
</script>
<style lang="scss" scoped></style>
